import { useSearchBarContext } from "@omni/components/components/Search/SearchBar/context/searchBar.context";
import { useGranite } from "@omni/components/redux/modules/value/translations/translations.provider";
import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

export const CloseButton = () => {
    const { onClose } = useSearchBarContext();
    const { t } = useGranite();

    return (
        <Button
            type={"button"}
            color={"transparent"}
            size={"sm"}
            className={cn("tw:font-normal")}
            onClick={onClose}
            tabIndex={0}
            aria-label={t("accessibility.searchBox.close")}
        >
            {t("searchBox.panel.resultsPanel.closeButton")}
            <i className={cn("tw:pl-2 las la-times")} />
        </Button>
    );
};
